// extracted by mini-css-extract-plugin
module.exports = {"modalHeader":"ReasonModal_modalHeader__1rPbM","modalBody":"ReasonModal_modalBody__3qoC8","submitBtnDiv":"ReasonModal_submitBtnDiv__2cKvl"};